import * as Yup from 'yup';
import React, { useState, useRef, useEffect } from 'react';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Typography,
  Avatar,
  Chip,
  Card,
  Input,
  Button
} from '@mui/material';
import { Box } from '@mui/system';
import { makeStyles, styled } from '@mui/styles';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
import { ToastContainer, toast } from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    position: 'relative',
    height: '100px'
  },
  header: {
    display: 'flex',
    position: 'absolute',
    width: 'calc(100%)',
    top: '-70px',
    alignItems: 'flex-end',
    '& > *': {
      margin: '24px 8px'
    }
  },
  spacer: {
    flexGrow: '1'
  },
  avatar: {
    border: `3px solid white`,
    width: 80,
    height: 80
  },
  actionGroup: {
    display: 'flex',
    width: '330px',
    justifyContent: 'space-between',
    marginRight: 0
  },
  summaryCards: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  summaryCard: {
    margin: 8,
    flexGrow: 1,
    padding: 24
  },
  tripCard: {
    margin: 8,
    padding: 16
  },
  input: {
    display: 'none'
  },
  large: {
    width: 100,
    height: 100
  }
}));

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#f78181'
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#f78181'
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'lightgray'
    },
    '&:hover fieldset': {
      borderColor: '#f78181'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#f78181'
    }
  }
});

export default function ProfileNurseryForm() {
  const [t, i18n] = useTranslation();
  const classes = useStyles();
  const [baseImage, setBaseImage] = useState('');
  const [client, setClient] = useState([]);
  const [userName, setUserName] = useState('');

  function convertBase64(photo) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(photo);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }
  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setBaseImage(base64);
  };
  const hiddenFileInput = React.useRef(null);
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const notifySuccess = () => {
    toast.success('Your nursery has been updated', {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };
  const notifyErrorProfile = (messageError) => {
    toast.error(messageError, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };
  // GET one Nursery
  const { id } = useParams();
  const retrieveArtisan = async () => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const response = await axios({
      method: 'get',
      url: `${API_ENDPOINT}/api/detail_creche/${id}`,
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.user;
  };

  useEffect(async () => {
    const oneClient = await retrieveArtisan();
    console.log('creche', oneClient);
    setClient(oneClient);
    setUserName(oneClient.username);
  }, []);

  const ProfileSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    username: Yup.string().required('Full name is required'),
    phone: Yup.string().required('Phone is required')
  });

  const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: client.username,
      email: client.email,
      phone: client.phone,
      photo: `${API_ENDPOINT}${client.photo}`
    },
    validationSchema: ProfileSchema,
    onSubmit: (values) => {
      const pic = `${API_ENDPOINT}${client.photo}`;
      const formData = new FormData();
      formData.append('username', values.username);
      formData.append('email', values.email);
      formData.append('phone', values.phone);
      if (pic !== values.photo) {
        formData.append('photo', values.photo);
      }
      const token = localStorage.getItem('access');
      console.log('data', values);
      axios({
        method: 'put',
        url: `${API_ENDPOINT}/api/detail_creche/${id}/`,
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
        data: formData
      })
        .then((res) => {
          setUserName(res.data.username);
          notifySuccess();
          console.log('response.data', res.data.data);
        })
        .catch((err) => {
          console.log('err', err);
          if (err.response.status >= 500) {
            notifyErrorProfile('Network Error');
          } else if (err.response.status >= 400 && err.response.status <= 403) {
            notifyErrorProfile('Email or phone number already bound to an existing account.');
          } else {
            notifyErrorProfile(err.message);
          }
        });
    }
  });
  const { errors, touched, isSubmitting, getFieldProps, setFieldValue, values } = formik;

  if (client.length === 0) {
    return (
      <div>
        <h1>Load ...</h1>
      </div>
    );
  }

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
        <ToastContainer />
        <div
          style={{
            height: '300px',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            filter: 'contrast(75%)',
            backgroundImage: 'url(/static/slider/child.jpg)'
          }}
        />
        <div className={classes.headerContainer}>
          <div className={classes.header}>
            <IconButton
              onClick={handleClick}
              color="primary"
              aria-label="upload picture"
              component="span"
            >
              <Avatar
                alt="ikram"
                classes={{ root: classes.large }}
                src={baseImage || values.photo}
              />
            </IconButton>
            <input
              type="file"
              style={{ display: 'none' }}
              multiple={false}
              ref={hiddenFileInput}
              onChange={(e) => {
                uploadImage(e);
                setFieldValue('photo', e.currentTarget.files[0]);
              }}
            />
            <Typography style={{ padding: '0px 30px', textTransform: 'capitalize' }} variant="h5">
              {userName}
            </Typography>
            <Chip style={{ backgroundColor: '#ec8181', color: 'white' }} label="Crèche" />
          </div>
        </div>
        <Stack style={{ padding: '30px' }} spacing={3}>
          <CssTextField
            fullWidth
            required
            type="text"
            label={t('NometPrénom')}
            {...getFieldProps('username')}
            error={Boolean(touched.username && errors.username)}
            helperText={touched.username && errors.username}
          />
          <CssTextField
            fullWidth
            required
            autoComplete="username"
            type="email"
            label={t('email')}
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />
          <CssTextField
            fullWidth
            required
            label={t('phone')}
            type="text"
            {...getFieldProps('phone')}
            error={Boolean(touched.phone && errors.phone)}
            helperText={touched.phone && errors.phone}
          />
          <Box textAlign="right" justifyContent="space-between">
            <Button
              style={{ maxWidth: '100px', backgroundColor: '#f78181' }}
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              {t('modifier')}
            </Button>
          </Box>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
